import React from 'react';
import usePublications from '../../../../src/hooks/usePublications/usePublications';
import Publication from '../../Publication/Publication';
import { useSelector } from 'react-redux';
import useParticipants from '../../../../src/hooks/useParticipants/useParticipants';
function ParticipantData(props) {
    const { videoidentity } = props;
    const participants = useParticipants();
    const videoParticipant = participants.find(e => e.identity === videoidentity);
    const publications = usePublications(videoParticipant);
    const dataPublications = publications === null || publications === void 0 ? void 0 : publications.filter(p => { var _a; return ((_a = p.track) === null || _a === void 0 ? void 0 : _a.kind) === 'data'; });
    const dataPublication = dataPublications && dataPublications.length > 0 ? dataPublications[0] : undefined;
    if (!dataPublication) {
        return null;
    }
    return (React.createElement(Publication, { kind: "data", publication: dataPublication, participant: videoParticipant, isLocal: false }));
}
export default function DNAParticipantData() {
    const remoteParticipants = useSelector((state) => state.virtualRoom.remoteParticpants);
    return (React.createElement(React.Fragment, null, remoteParticipants === null || remoteParticipants === void 0 ? void 0 : remoteParticipants.map((participant) => {
        return (React.createElement(ParticipantData, { key: `${participant.videoIdentity}`, videoidentity: participant.videoIdentity }));
    })));
}
//# sourceMappingURL=DNAParticipantData.js.map